import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Badges, LI, UL } from '../../../AbstractElements'
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { RootState } from '../../../ReduxToolkit/Store';
import { setIsSearchBarOpen } from '../../../ReduxToolkit/Reducers/Layout/LayoutReducer';
import NotificationBox from './NotificationBox';
import MoonLight from './MoonLight';
import ChatHeader from './ChatHeader';
import CartHeader from './CartHeader';
import ProfileHeader from './ProfileHeader';
import MaximizeScreen from './MaximizeScreen';
import BookmarkHeader from './BookmarkHeader';
import { useNavigate } from 'react-router-dom';
import TableOfContents from '../../../Utils/User Manual/TableContent';
import { pdfBasePath } from '../../../Utils/User Manual/userManual';


export default function RightHeader() {
    const dispatch = useDispatch();
    const { isSearchBarOpen } = useSelector((state: RootState) => state.layout);
    const navigate = useNavigate();
    const [isTocOpen, setIsTocOpen] = useState(false);
    const handleSearch = () => {
        dispatch(setIsSearchBarOpen(!isSearchBarOpen));
    }

    const handleAppClick = () => {
        navigate(`/organization-apps`);
    }

    const goToChat = () => {
        navigate(`/applications/chat/chat_private`);
    }

    const toggleToc = () => {
        setIsTocOpen(prev => !prev);
    };

    return (
        <>
            <UL className="nav-menus simple-list flex-row">
                <LI>
                    <svg
                        onClick={handleAppClick}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#1f1f1f"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ cursor: "pointer" }}
                    >
                        <path d="M3 9.5L12 3l9 6.5V21a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5H10v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
                    </svg>
                </LI>
                <LI>
                    <span className="header-search">
                        <SvgIcon iconId='search' onClick={handleSearch} />
                    </span>
                </LI>

                {/* Help Icon — hover dropdown like profile, click opens TOC modal */}
                <LI className="profile-nav onhover-dropdown">
                    <div
                        className="onhover-click"
                        style={{ display: 'flex', alignItems: 'center', padding: '0 10px', cursor: 'pointer' }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#1f1f1f"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                            <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                    </div>

                    {/* Dropdown — same CSS classes as profile dropdown */}
                    <UL className="profile-dropdown onhover-show-div simple-list">
                        <LI>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsTocOpen(true); // opens TableOfContents modal → PDF viewer inside
                                }}
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                                <div className="profile-icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                                        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                                    </svg>
                                </div>
                                <span>Help</span>
                            </a>
                        </LI>
                    </UL>
                </LI>
                <MaximizeScreen />
                {/* <NotificationBox /> */}
                <BookmarkHeader />
                {/* <LI>

                <div style={{ cursor: 'pointer' }} className="cart-box onhover-click" onClick={goToChat} >
                    <SvgIcon iconId='email' />
                    <Badges color='danger' pill>{'2'}</Badges>
                </div>

            </LI> */}
                {/* <ChatHeader /> */}
                {/* <MoonLight />
            <CartHeader /> */}
                <ProfileHeader />

                {/* Apps Icon */}
                <LI>
                    <span className="header-search">
                        <SvgIcon iconId='apps' onClick={handleSearch} />
                    </span>
                </LI>
            </UL>
            <TableOfContents
                isOpen={isTocOpen}
                toggle={toggleToc}
                pdfPath={pdfBasePath}
            />
        </>
    )
}